import { withStyles } from '@material-ui/core/styles';
import OrderReceipt from './OrderReceipt';
import styles from './OrderReceipt.styles';

export default withStyles(styles)(OrderReceipt);
